import { palette } from "@wato/ui";

/** WP-125: sets `<meta name="theme-color">` (`index.html`) from the `@wato/ui` design
 * token at runtime, so the brand colour has one source of truth instead of a literal
 * hard-coded in `index.html` (the RTL/logical-CSS lint (`--strict-values`) flags raw hex
 * values in scanned `.html`/`.ts`/`.tsx` files — `palette` itself lives in `@wato/ui`,
 * outside the dashboard's lint scope). Matches `manifest.json`'s `theme_color`. */
export function setThemeColor(): void {
  document.querySelector('meta[name="theme-color"]')?.setAttribute("content", palette.primary[600]);
}
